/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Import Failed" |
*
* @param {Editor_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_failed = /** @type {((inputs?: Editor_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de l'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт не удался.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación fallida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação falhou")
	return /** @type {LocalizedString} */ ("Import Failed")
});